import createInstance from "./interceptors";

const API_URL = process.env.VUE_APP_API_BASE_URL + "/api";

class RecordTable {
  // getCsv(data) {
  //   const instance = axios.create({
  //     headers: authHeader(),
  //     responseType: "blob",
  //   });
  //
  //   return instance.post(API_URL + "/user/export", data).then((response) => {
  //     return {
  //       type: response.headers["content-type"],
  //       data: response.data,
  //     };
  //   });
  // }

  getFilters() {
    const instance = createInstance();

    return instance.get(API_URL + "/user/filter").then((response) => {
      return response.data;
    });
  }

  filter(data) {
    const instance = createInstance();

    return instance.post(API_URL + "/user/filter", data).then((response) => {
      return response.data;
    });
  }
}

export default new RecordTable();
